import { useEffect } from "react";

const ZOOM_RATIO = 0.15;
const MIN_ZOOM_INTERVAL_MS = 30;

/**
 * Ctrl/Cmd + wheel zooms the whole Gantt, anchored on the pointer.
 *
 * The library only binds its own wheel zoom to the chart area, so without this
 * the same gesture zooms over the chart and scrolls over the grid. Handling it
 * on the container in the capture phase keeps the two from happening at once.
 */
const useGanttWheelZoom = ({ containerRef, ganttApi }) => {
	useEffect(() => {
		const container = containerRef.current;
		if (!container || !ganttApi) return undefined;

		let lastZoomAt = 0;

		const handleWheel = (event) => {
			if (!event.ctrlKey && !event.metaKey) return;

			event.preventDefault();
			event.stopPropagation();

			if (event.timeStamp - lastZoomAt < MIN_ZOOM_INTERVAL_MS) return;
			lastZoomAt = event.timeStamp;

			const chart = container.querySelector(".wx-chart");
			if (!chart) return;

			const bounds = chart.getBoundingClientRect();
			const offset = Math.min(
				Math.max(event.clientX - bounds.left, 0),
				bounds.width
			);

			ganttApi.exec("zoom-scale", {
				dir: event.deltaY < 0 ? 1 : -1,
				ratio: ZOOM_RATIO,
				offset,
			});
		};

		const options = { capture: true, passive: false };
		container.addEventListener("wheel", handleWheel, options);

		return () => container.removeEventListener("wheel", handleWheel, options);
	}, [containerRef, ganttApi]);
};

export default useGanttWheelZoom;
